// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../../../assets/stylesheets/variables.scss\"","slateColor":"#555555","container":"RemoveBackground_container__Jzq5k"};